import { render, staticRenderFns } from "./bind-record.vue?vue&type=template&id=1432f2eb&"
import script from "./bind-record.vue?vue&type=script&lang=js&"
export * from "./bind-record.vue?vue&type=script&lang=js&"
import style0 from "./bind-record.vue?vue&type=style&index=0&id=1432f2eb&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports